import React from 'react'
import YearMonthSelector from "./YearMonthSelector"

export default class ReuseArticle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMonths: {}
    };
    this.handleSelectedMonth = this.handleSelectedMonth.bind(this)
  }

  setSelectedDatesOnTarget(months) {
    if (!this.props.target) { return; }

    const selectedMonths = $.map(months, (val, key) => {
      return val ? key : null;
    });
    $(this.props.target).val($.grep(selectedMonths, (val) => val));
  }

  handleSelectedMonth(month) {
    let updatedMonths = $.extend(
      {},
      this.state.selectedMonths,
      { [month]: !this.state.selectedMonths[month] }
    )
    this.setState({ selectedMonths: updatedMonths });
    this.setSelectedDatesOnTarget(updatedMonths);
  }

  render() {
    let yearSections = $.map(this.props.dates, (months, year) => {
      return (
        <YearMonthSelector
          key={year}
          year={year}
          months={months}
          selected={this.state.selectedMonths}
          labels={this.props.labels}
          onMonthClick={this.handleSelectedMonth} />
      );
    });

    return (
      <div>
        {yearSections}
      </div>
    );
  }
}
